export default __webpack_public_path__ + "static/media/offer.f25a0c80.webp";